import { EMPTY_OBJECT } from '../../../constants/common'
import { getItemsIds } from '../../../utils/common'
import {
  CHATROOM_INPUT_TEMPLATES_API_PARAMS,
  CHATROOM_TYPE,
} from '../Chatroom.constants'

export function getChatroomInputTemplatesApiParams(buildingId) {
  return Number.isFinite(buildingId)
    ? { ...CHATROOM_INPUT_TEMPLATES_API_PARAMS, for_building: buildingId }
    : CHATROOM_INPUT_TEMPLATES_API_PARAMS
}

export function getChatroomInputDraftKey({ chatroomUuid, isPublic }) {
  return (
    chatroomUuid || (isPublic ? CHATROOM_TYPE.Public : CHATROOM_TYPE.Private)
  )
}

export function getChatroomCreateMessagePayload({ chatroom, files, text }) {
  return {
    chatroom,
    files: getItemsIds(files),
    text,
  }
}

export function getChatroomCreateWithMessagePayload({
  createChatroomParams = EMPTY_OBJECT,
  files,
  isPublic,
  text,
}) {
  return {
    ...createChatroomParams,
    files: getItemsIds(files),
    is_public: isPublic,
    text,
  }
}

export function getChatroomInputIsAIEnabled({
  aiFeatures,
  canSendAiGeneratedMessage,
}) {
  return canSendAiGeneratedMessage && aiFeatures?.text_generation
}

export function getChatroomInputIsSendDisabled({
  files,
  filesUploading,
  hasMessageContent,
  isSubmitting,
}) {
  return (
    isSubmitting ||
    filesUploading.length > 0 ||
    (!hasMessageContent && files.length === 0)
  )
}
